/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter, Link } from 'react-router-dom';
// import axios from "axios";

import FindId from '../containers/findAcount/FindId';
import FindPassword from '../containers/findAcount/FindPassword';
import FindIdResult from '../containers/findAcount/FindIdResult';
import FindPwdResult from '../containers/findAcount/FindPwdResult';

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

class FindAcount extends Component {
  state = {
    tabIndex: 0,
    findIdCode: 100,
    findPwdCode: 100,
    findId: '',
  };

  _toggleTab = (tabIndex) => {
    this.setState({
      tabIndex,
    });
  };
  _onFindIdCode = (findIdCode, findId, tabIndex) => {
    //console.log(findIdCode, findId)
    this.setState({
      findIdCode,
      findId,
      tabIndex,
    });
  };
  _onFindPwdCode = (findPwdCode, findId) => {
    this.setState({
      findPwdCode,
      findId,
    });
  };
  render() {
    const { tabIndex, findIdCode, findPwdCode, findId } = this.state;
    const { imgUrl } = this.props;
    return (
      <Fragment>
        <div className="login_container">
          <div className="login_logo">
            <Link to="/">
              <img src={imgUrl + '/img/login_img/login_logo.png'} />
            </Link>
          </div>
          <div className="join_btn">
            <Link to="/join">회원가입</Link>
          </div>
          <img
            src={imgUrl + '/img/login_img/open_img.png'}
            className="open_img"
          />

          <div
            className={
              tabIndex === 0 ? 'login_content width2' : 'login_content width3'
            }
          >
            <div className="login_tab">
              <a
                style={{ cursor: 'pointer' }}
                className={tabIndex === 0 ? 'on' : null}
                onClick={() => this._toggleTab(0)}
              >
                아이디 찾기
              </a>
              <a
                style={{ cursor: 'pointer' }}
                className={tabIndex === 1 ? 'on' : null}
                onClick={() => this._toggleTab(1)}
              >
                비밀번호 찾기
              </a>
            </div>

            {tabIndex === 0 ? (
              findIdCode === 100 ? (
                <FindId onFindIdCode={this._onFindIdCode} />
              ) : (
                <FindIdResult
                  findIdCode={findIdCode}
                  onFindIdCode={this._onFindIdCode}
                  findId={findId}
                />
              )
            ) : findPwdCode === 100 ? (
              <FindPassword
                findPwdCode={findPwdCode}
                onFindPwdCode={this._onFindPwdCode}
              />
            ) : (
              <FindPwdResult
                findPwdCode={findPwdCode}
                onFindPwdCode={this._onFindPwdCode}
                findId={findId}
              />
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(FindAcount));
